module.exports = __webpack_public_path__ + "img/ic_penchart.d9daf207.svg";